import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Type20Service {

  private subtype = new BehaviorSubject<string[]>([]);
  public customOption = this.subtype.asObservable();
  public type:number;
  constructor() {}
  public changeOption(id:number,subtype:any[]): void {
    this.type = id;
    this.subtype.next(this.store(id,subtype));
  }
  public store(id:number,subtype: any[]):string[]{
    let data = subtype.find(el => Number(id) === el.typeId)
   return data.items
  }
  public getType():number{
   return this.type
  }
}
